import { useAuth, useClerk } from '@clerk/react'
import { Flame } from 'lucide-react'
import { useState } from 'react'

import { useStreak } from '@/components/streak-context'
import { StreakModal } from '@/components/ui/streak-modal'
import { trpc } from '@/lib/trpc'
import { cn } from '@/lib/utils'

export function StreakCounter() {
  const { isSignedIn } = useAuth()
  const { openSignIn } = useClerk()
  const { flameActive } = useStreak()
  const [manualModalOpen, setManualModalOpen] = useState(false)

  const { data } = trpc.streak.get.useQuery(undefined, {
    enabled: !!isSignedIn,
  })

  const currentStreak = data?.currentStreak ?? 0
  const completedToday = data?.completedToday ?? false
  const hasStreak = isSignedIn && currentStreak > 0

  const handleClick = () => {
    if (!isSignedIn) {
      openSignIn()
      return
    }
    setManualModalOpen(true)
  }

  return (
    <>
      <button
        type="button"
        onClick={handleClick}
        className={cn(
          'flex items-center gap-1 rounded-md px-2 py-1.5 text-sm font-medium transition-colors',
          'hover:bg-accent hover:text-accent-foreground',
          !isSignedIn && 'text-muted-foreground',
        )}
        aria-label={`Streak: ${currentStreak} days`}
      >
        <Flame
          className={cn(
            'h-5 w-5 transition-colors',
            hasStreak
              ? 'fill-orange-500 text-orange-500'
              : 'text-muted-foreground',
            flameActive &&
              'animate-[flicker_0.5s_ease-in-out_infinite_alternate]',
          )}
        />
        <span>{currentStreak}</span>
      </button>

      <StreakModal
        open={manualModalOpen}
        onClose={() => setManualModalOpen(false)}
        currentStreak={currentStreak}
        earned={completedToday}
      />
    </>
  )
}
